// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-container::-webkit-scrollbar{width:10px;border-radius:5px}.scroll-container::-webkit-scrollbar-track{background:#f1f1f1}.scroll-container::-webkit-scrollbar-thumb{background-color:#888;border-radius:10px}.scroll-container::-webkit-scrollbar-thumb:hover{background-color:#555}.scroll-container{scrollbar-width:thin;scrollbar-color:#888 #f1f1f1}.full-height-img{height:100%;width:auto}.promotion_class{opacity:.75}.promotion_class:hover{opacity:1}", ""]);
// Exports
module.exports = exports;
